import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const ProseContainer = styled.div`
    max-width: none;
    color: ${colourScheme.white};

    a {
        color: ${colourScheme.success};
        text-decoration: underline;
        &:hover {
            text-decoration: none;
        }
    }

    div.lead {
        font-size: 1.25rem;
        font-weight: 300;
        line-height: 1.6;
        margin-bottom: 1.5rem;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-weight: bold;
        line-height: 1.25;
    }

    h1 {
        font-size: 2.5rem;
        margin-top: 2rem;
        margin-bottom: 1.5rem;
    }

    h2 {
        font-size: 2rem;
        margin-top: 1.75rem;
        margin-bottom: 1.25rem;
    }

    h3 {
        font-size: 1.75rem;
        margin-top: 1.5rem;
        margin-bottom: 1rem;
    }

    h4 {
        font-size: 1.5rem;
        margin-top: 1.25rem;
        margin-bottom: 0.75rem;
    }

    h5 {
        font-size: 1.25rem;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
    }

    h6 {
        font-size: 1rem;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
    }

    p {
        margin: 1.25rem 0;
        line-height: 1.75;
        color: inherit;
    }

    p > p {
        margin: 0;
    }

    ul,
    ol {
        margin: 1.25rem 0;
        padding-left: 2rem;
    }

    li {
        margin: 0.75rem 0;
    }

    blockquote {
        margin: 1.5rem 0;
        padding: 1rem 1.5rem;
        background-color: ${colourScheme.primaryDark};
        border-left: 5px solid ${colourScheme.secondaryDark};
        color: ${colourScheme.fullWhite};
        font-style: italic;
    }

    pre,
    code {
        font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
    }

    pre {
        padding: 1.5rem;
        overflow: auto;
        white-space: pre;
        background-color: ${colourScheme.primaryDark};
        border: 1px solid ${colourScheme.grey};
        margin: 1.5rem 0;
    }

    code {
        background-color: ${colourScheme.primaryDark};
        border: 1px solid ${colourScheme.grey};
        padding: 0.25rem 0.5rem;
        border-radius: 0.375rem;
        white-space: pre-wrap;
    }

    img {
        max-width: 100%;
        height: auto;
        margin: 1.5rem 0;
    }

    figure {
        margin: 1.75rem 0;
        text-align: center;

        img {
            margin: 0 auto;
        }

        figcaption {
            margin-top: 0.75rem;
            font-size: 0.875rem;
            color: ${colourScheme.grey};
        }
    }

    table {
        width: 100%;
        margin: 1.5rem 0;
        border-collapse: collapse;
    }

    th,
    td {
        padding: 0.75rem;
        border: 1px solid ${colourScheme.grey};
    }

    th {
        background-color: ${colourScheme.primaryLight};
        font-weight: bold;
    }

    td {
        background-color: ${colourScheme.primaryDark};
    }

    strong {
        font-weight: bold;
    }

    em {
        font-style: italic;
    }
`;
